import { render, staticRenderFns } from "./CategoryProblem.vue.js?vue&type=template&id=27e7944d&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CategoryProblem.vue?vue&type=template&id=27e7944d&scoped=true"
import script from "./CategoryProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CategoryProblem.vue?vue&type=script&lang=js"
export * from "./CategoryProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CategoryProblem.vue?vue&type=script&lang=js"
import style0 from "./CategoryProblem.vue.css?vue&type=style&index=0&id=27e7944d&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CategoryProblem.vue?vue&type=style&index=0&id=27e7944d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7944d",
  null
  
)

export default component.exports